import { Study } from '../study';

export class StudyModalsPayload {
  studyId: number;
  study: Study;
}
